<template>
<div>
    <navi selectedid="tlMediaCenter"></navi>
    <subNavi selectedid="tlNews" lastrouter="/media/interaction" nextrouter="/media/video"></subNavi>
    
    <div id="Contents">
        <!-- <div id="Logo">
            <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>
            <h2 title="HOME"><a href="../index.html" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229" height="219"></a></h2>

            <siteMenu></siteMenu>
        </div> -->
        <logo selectedid="tlMediaCenter"></logo>

        <spNavi selectedid="tlNews"></spNavi>

        <div id="Main">
            <div class="media-article">
                <div class="media-list">
                    <dl v-for="item in news">
                        <dt>{{item.published_date}}</dt><dd><a v-bind:href="'/media/news/'+item.id">{{item.title}}</a></dd>
                    </dl>
                </div>
                <paginate :page-count="pageCount" :prev-text="$t('lbPrev')" :next-text="$t('lbNext')" :click-handler="pageClick" :container-class="'pagination'" :page-class="'page-item'"></paginate>
            </div>
            <div class="swiper-container" style="height: 240px;">
              <div class="swiper-wrapper">
                <div class="swiper-slide border-wrap" v-for="item in image_news" :title="item.title" >
                  <a :href="'/media/news/' + item.id"><img style="width: 99%; height: 95%;" :src="item.image"></a>
                </div>
             

                <!-- <div class="swiper-slide" style="margin: 0px 10px; width: 300px; height: 200px;"><img src="http://service.arivotyre.com/upload/images/QQ图片20190319081743.jpg"></div>
                <div class="swiper-slide" style="margin: 0px 10px; width: 300px; height: 200px;"><img src="http://service.arivotyre.com/upload/images/QQ图片20190319081743.jpg"></div>
                <div class="swiper-slide" style="margin: 0px 10px; width: 300px; height: 200px;"><img src="http://service.arivotyre.com/upload/images/QQ图片20190319081743.jpg"></div>
                <div class="swiper-slide" style="margin: 0px 10px; width: 300px; height: 200px;"><img src="http://service.arivotyre.com/upload/images/QQ图片20190319081743.jpg"></div>
                <div class="swiper-slide" style="margin: 0px 10px; width: 300px; height: 200px;"><img src="http://service.arivotyre.com/upload/images/QQ图片20190319081743.jpg"></div> -->
              </div>
              <!-- Add Pagination -->
              <div class="swiper-pagination"></div>
            </div>
            <share></share>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>
import Navi from "components/common/navi";
import SubNavi from "components/media/subnavi";
import Logo from "components/common/logo";
import SpNavi from "components/media/spnavi";
import Share from "components/common/share";
import WebFooter from "components/common/footer";
import Paginate from "vuejs-paginate";
import newsApi from "../../api/news-api";
import _util from "../../utils";
import _ from "lodash";
import Swiper from "swiper";
export default {
  name: "News",
  components: {
    Navi,
    SubNavi,
    Logo,
    SpNavi,
    Share,
    WebFooter,
    Paginate
  },
  data() {
    return {
      page: 1,
      pageCount: 1,
      news: [],
      image_news: [],
      lastPageUrl: "",
      nextPageUrl: "",
      newsCount: "",
      lang: _util.getCurrentLang()
    };
  },
  updated() {
    // this.getNews();
    // this.getImageNews();
    var swiper = new Swiper(".swiper-container", {
        slidesPerView: 4,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      });
    
  },
  created: function() {
    this.getNews();
    this.getImageNews();
  },
  mounted: function() {
    // this.getNews();
    // this.getImageNews();
    // this.$nextTick(function() {
    //   var swiper = new Swiper(".swiper-container", {
    //     initialSlide: 0,
    //     observer: true,
    //     pagination: {
    //       el: ".swiper-pagination",
    //       clickable: true
    //     }
    //   });
    // });
  },
  methods: {
    getNews() {
      var c_page = _util.getUrlParam("page");
      if (!c_page) {
        this.page = 1;
      }
      var _this = this;
      newsApi.getNewList(
        this.page,
        function(response) {
          _this.page = response.current_page;
          _this.pageCount = response.last_page;
          _this.lastPageUrl = response.last_page_url;
          _this.nextPageUrl = response.next_page_url;
          _this.newsCount = response.total;
          _this.news = response.data;
        },
        function(error) {
          console.log("error: ");
          console.log(error);
        }
      );
    },
    getImageNews() {
      var _this = this;
      newsApi.getImageNewsList(function(response) {
        let new_list = response.data;
        _this.image_news = _.filter(new_list, function(o) {
          return o.image != undefined && o.image != "";
        });
      });
    },
    pageClick(pageNum) {
      alert(pageNum);
      window.location.href = "/media/news?page=" + pageNum;
    }
  }
};
</script>
<style>
@import "../../common/css/swiper.css";
.news .swiper-container {
  width: 100%;
  height: 150px;
}
.news .swiper-container .swiper-slide {
  text-align: center;
  width: 150px !important;
  margin: 0px 15px;
  height: 96% !important;
  overflow: hidden !important;
  font-size: 18px;
  background: transparent;
  /* Center slide text vertically */
  cursor: pointer;
  align-items: center;
}
.pagination {
  margin: 10px 50%;
  width: 100%;
}
.pagination li {
  float: left;
  width: 50px;
  border: 1px solid white;
  border-radius: 15px;
  margin: 0px 5px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/media/news.vue